import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import SideMenu from './components/SideMenu';
import MainContent from './components/MainContent';
import Ticker from './components/Ticker';
import Notes from './components/Notes';
import Secrets from './components/Secrets';
import Archives from './components/Archives';
import ArchivePost from './components/ArchivePost';
import Parenting from './components/Parenting';
import Admin from './components/Admin';
import EditPost from './components/EditPost';
import EditArchive from './components/EditArchive';
import EditJournal from './components/EditJournal';
import Journal from './components/Journal';
import Login from './components/auth/Login';
import DebugAuth from './components/DebugAuth';
import Laddu from './components/Laddu';
import Health from './components/Health';
import AI from './components/AI';
import Notepad from './components/Notepad';
import ProtectedRoute from './components/ProtectedRoute';
import { ROUTES, HOME_ROUTE } from './constants/routes';
import { PRIVATE_ROUTES } from './constants/private_route';
import homeData from './data/home.json';
import './styles.css';
import { useHideSideMenu } from './hooks/useHideSideMenu';
import { initializeAuth } from './services/authService';
import initService from './services/initService';
import databaseService from './services/databaseService';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAthckwXdfaee9qej7bTQQG-O8iezWgjJI",
  authDomain: "psudeep-blog.firebaseapp.com",
  projectId: "psudeep-blog",
  storageBucket: "psudeep-blog.appspot.com",
  messagingSenderId: "147728999116",
  appId: "1:147728999116:web:1af55aa8929129b02e9869",
  measurementId: "G-1RHGL7H70Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

function AppContent() {
  const location = useLocation();
  const hideSideMenu = useHideSideMenu(location.pathname);
  const [showTicker, setShowTicker] = useState(true);

         // Initialize authentication and database on app start
         useEffect(() => {
           const initializeApp = async () => {
             try {
               await initService.initialize();
               initializeAuth();

               // Make initService available globally for debugging
               window.initService = initService;
               window.databaseService = databaseService;
               console.log('Debug: Use window.initService.resetDatabase() to reset the database if needed');
               console.log('Debug: Use window.databaseService.init() to test database initialization');
             } catch (error) {
               console.error('Failed to initialize app:', error);
             }
           };

           initializeApp();
         }, []);

  // Show ticker only on home page
  const isHomePage = location.pathname === '/';

  return (
    <div className="app-container">
      <main className="main-content">
        {isHomePage && showTicker && (
          <Ticker
            message="New: Demystifying the AI Architecture — From Silicon to Alignment"
            link="/ai/blogs/ai-technology-stack"
            onClose={() => setShowTicker(false)}
          />
        )}
        <Routes>
          <Route path={HOME_ROUTE.path} element={<MainContent content={homeData} />} />
          <Route path="/:page_title" element={<MainContent />} />
          <Route path="/n/notes" element={
            <ProtectedRoute>
              <Notes />
            </ProtectedRoute>
          } />
          <Route path="/n/secrets" element={
            <ProtectedRoute>
              <Secrets />
            </ProtectedRoute>
          } />
          <Route path="/archives" element={<Archives />} />
          <Route path="/archives/:post_title" element={<ArchivePost />} />
          <Route path="/parenting" element={<Parenting />} />
                 <Route path="/admin" element={
                   <ProtectedRoute>
                     <Admin />
                   </ProtectedRoute>
                 } />
                 <Route path="/admin/edit/post/:postId" element={
                   <ProtectedRoute>
                     <EditPost />
                   </ProtectedRoute>
                 } />
                 <Route path="/admin/edit/archive/:archiveId" element={
                   <ProtectedRoute>
                     <EditArchive />
                   </ProtectedRoute>
                 } />
                 <Route path="/admin/edit/journal/:journalId" element={
                   <ProtectedRoute>
                     <EditJournal />
                   </ProtectedRoute>
                 } />
                 <Route path="/journal" element={
                   <ProtectedRoute>
                     <Journal />
                   </ProtectedRoute>
                 } />
                 <Route path="/f/:page_title" element={<MainContent />} />
                 <Route path="/page/:page_title" element={<MainContent />} />
                 <Route path="/auth/login" element={<Login />} />
                 <Route path="/debug-auth" element={<DebugAuth />} />
                 <Route path="/laddu" element={<Laddu />} />
                 <Route path="/laddu/:letter_slug" element={<Laddu />} />
                 <Route path="/health/*" element={<Health />} />
                 <Route path="/ai/*" element={<AI />} />
                 <Route path="/notes/*" element={<Notepad />} />
                 {/* Add any new routes here */}
        </Routes>
      </main>
      {!hideSideMenu && <SideMenu items={ROUTES} />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;